/**
 * The `maxLength` the free-text inputs on the creation/edit forms carry (DEV-4426).
 *
 * These MIRROR the server's bounds — `MAX_LEN` and `MAX_EMAIL_LEN` in
 * `apps/api/src/common/optional-trimmed.ts`, which is the single owner of the real rule.
 * They are declared here rather than imported for the reason `lib/enum-sync.test.ts`
 * documents at length for the enum lists: importing runtime values across that boundary
 * breaks the production `vite build`. Unlike those lists there is no cheap sync guard for a
 * number, so the coupling is this comment — and it only fails SAFE. `maxLength` is an
 * ergonomic guard, not the gate: dropping it changes nothing about what the API accepts, and
 * a value that slipped past it is refused with a 400 naming the field.
 *
 * Deliberately NOT applied to the search/filter inputs on the same screens. Those never
 * round-trip to a bounded field, so a cap there would be an invented restriction rather than
 * a mirror of one. And deliberately NOT a character filter: the server is the gate, and a
 * client that silently swallowed keystrokes would make a legitimate `Bjørnøya` look broken.
 */
export const MAX_TEXT_LEN = 200;

/** @see MAX_TEXT_LEN — the server's `MAX_EMAIL_LEN` (RFC 5321's 64 + `@` + 255). */
export const MAX_EMAIL_LEN = 320;

/**
 * @see MAX_TEXT_LEN — the server's `MAX_REASON_LEN`, for the PROSE fields (an audit reason,
 * a rejection note) rather than the single-line ones.
 *
 * It lives here for the reason this module exists: the three reason textareas each carried
 * their own literal `2000`, which is the same one-copy-per-caller drift the server-side owner
 * was created to end. Note these fields take the bound and NO character policy server-side —
 * the name allowlist refuses `;`, `@` and newlines, which a prose box actively invites.
 */
export const MAX_REASON_LEN = 2000;
